// extracted by mini-css-extract-plugin
export var borderRadius = "_f3-4";
export var large = "_f3-3";
export var logoContainer = "_f3-0";
export var nameLogo = "_f3-2";
export var small = "_f3-1";